import { render } from "./ForgottedPassword.vue?vue&type=template&id=06c5de86&scoped=true"
import script from "./ForgottedPassword.vue?vue&type=script&lang=js"
export * from "./ForgottedPassword.vue?vue&type=script&lang=js"

import "./ForgottedPassword.vue?vue&type=style&index=0&id=06c5de86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c5de86"]])

export default __exports__